export default __webpack_public_path__ + "static/media/tablet-lumin-info.9f94dc5a.jpg";